import React from 'react';
import { alpha, useTheme } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';

const SHOW_LOGO = 'https://files.tnonetwork.com/shows/logo/vidainmobiliaria.png';

const Values = () => {
  const theme = useTheme();
  const primary = theme.palette.primary.main;

  const values = [
    {
      title: 'Nicho inmobiliario en TNO',
      subtitle: 'Programa referente en mercado, tendencias y conversación con expertos del sector.',
      icon: (
        <svg width={24} height={24} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
        </svg>
      ),
    },
    {
      title: 'Carolina Hernández',
      subtitle: 'Ancla que conecta mercado inmobiliario, inversión y patrimonio con la audiencia.',
      icon: (
        <svg width={24} height={24} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
        </svg>
      ),
    },
    {
      title: 'Impacto Multiplataforma',
      subtitle: 'Vivo, On-Demand, TNO Digest y redes. Tu mensaje donde está la audiencia.',
      icon: (
        <svg width={24} height={24} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9a9 9 0 01-9-9m9 9c1.657 0 3-4.03 3-9s-1.343-9-3-9m0 18c-1.657 0-3-4.03-3-9s1.343-9 3-9m-9 9a9 9 0 019-9" />
        </svg>
      ),
    },
    {
      title: 'Marcas del ecosistema hogar',
      subtitle: 'Ideal para inmobiliarias, bancos, constructoras, seguros y retail del hogar.',
      icon: (
        <svg width={24} height={24} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
        </svg>
      ),
    },
  ];

  return (
    <Box>
      <Box marginBottom={4}>
        <Typography sx={{ textTransform: 'uppercase', fontWeight: 'medium' }} gutterBottom color={'primary'} align={'center'}>
          Ventajas Competitivas
        </Typography>
        <Box component={Typography} sx={{ fontWeight: 700 }} variant={'h3'} gutterBottom align={'center'} color={'primary'}>
          ¿Por qué Vida Inmobiliaria?
        </Box>
      </Box>
      <Grid container spacing={4} alignItems="center">
        <Grid item xs={12} md={6}>
          <Box
            maxWidth={420}
            width="100%"
            mx="auto"
            sx={{
              minHeight: { xs: 260, sm: 300 },
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              borderRadius: 3,
              overflow: 'hidden',
              background: `linear-gradient(145deg, ${alpha(primary, 0.08)} 0%, ${alpha(primary, 0.03)} 100%)`,
              border: `1px solid ${alpha(primary, 0.14)}`,
              px: { xs: 3, sm: 4 },
              py: { xs: 4, sm: 5 },
            }}
          >
            <Box
              component="img"
              src={SHOW_LOGO}
              alt="Logo Vida Inmobiliaria"
              sx={{
                display: 'block',
                width: '100%',
                maxWidth: { xs: 220, sm: 280 },
                height: 'auto',
                objectFit: 'contain',
                mx: 'auto',
              }}
            />
          </Box>
        </Grid>
        <Grid item xs={12} md={6}>
          {values.map((item, index) => (
            <Box key={index} display="flex" alignItems="flex-start" marginBottom={4} data-aos="fade-up" data-aos-delay={index * 100}>
              <Box
                component="div"
                sx={{
                  width: 50,
                  height: 50,
                  borderRadius: '50%',
                  bgcolor: `${theme.palette.primary.light}22`,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  color: theme.palette.primary.main,
                  marginRight: 2,
                  flexShrink: 0,
                }}
              >
                {item.icon}
              </Box>
              <Box>
                <Typography variant="h6" gutterBottom sx={{ fontWeight: 700 }}>
                  {item.title}
                </Typography>
                <Typography color="textSecondary">{item.subtitle}</Typography>
              </Box>
            </Box>
          ))}
        </Grid>
      </Grid>
    </Box>
  );
};

export default Values;
